import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { QuoteList, QuoteDetail } from '../pages/quotes';

const QuoteRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<QuoteList />} />
      <Route path=":id" element={<QuoteDetail />} />
    </Routes>
  );
};

export default QuoteRoutes;
